<template>
  <div class='stats'>   
    <div v-if="stats.length === 4">
      <div class="row">
        <Stat         
                :label="stats[0].label" 
                :value="stats[0].value" 
                :suffix="stats[0].suffix" 
        />
        <Stat                   
                :label="stats[1].label" 
                :value="stats[1].value" 
                :suffix="stats[1].suffix" 
        />
      </div>
    <div class="row">
        <Stat                   
                :label="stats[2].label" 
                :value="stats[2].value" 
                :suffix="stats[2].suffix" 
        />
        <Stat v-if="stats.length == 4"
                :label="stats[3].label" 
                :value="stats[3].value" 
                :suffix="stats[3].suffix" 
        />
      </div>    
    </div>
    <div v-if="stats.length > 4">
      <template v-for="(stat, key) in stats">         
         <Stat :key="stat.label" limitWidth   
              :label="stat.label" 
              :value="stat.value" 
              :suffix="stat.suffix" 
        />   
        <div class="separator" :key="key" v-if="key > 0 && (key + 1) % 3 == 0"></div>
      </template>          
    </div>
    <div v-else>
      <Stat v-for="(stat, key) in stats" :key="key" limitWidth   
              :label="stat.label" 
              :value="stat.value" 
              :suffix="stat.suffix" 
      />       
    </div>
  </div>
</template>

<script>
import Stat from "@/patterns/Stat.vue";
export default {
  name: "Stats",
  data: () => ({}),
  components: {Stat},
  mounted() {},
  props: { stats: Array },
};
</script>


<style lang="scss" scoped>    
    .divider {
        display: inline-block;
        width: 1px;
        background:#fff;
        height:60px;
        margin:0 30px;;
    }        
    .separator {
      display: none;
    }
    @media (min-width:1545px) {
      .separator {
        display:block;
      }
    }
</style>
